import * as TP from '../types';

import { gql } from '@apollo/client';
export type EmployeeSimpleFragment = (
  { readonly __typename?: 'Employee' }
  & Pick<TP.Employee, 'companyEmail' | 'email' | 'emergencyContact' | 'emergencyPhone' | 'employeeDepartmentId' | 'employeeDisplayName' | 'employeeGenderId' | 'employeeGroupId' | 'employeeId' | 'employeeOfficeId' | 'employeeSuffixId' | 'ext' | 'firstName' | 'fullName' | 'id' | 'lastName' | 'middleName' | 'nickname' | 'personalEmail' | 'phoneNumber' | 'relationship' | 'title' | 'userId' | 'managerId'>
);

export const EmployeeSimpleFragmentDoc = gql`
    fragment EmployeeSimple on Employee {
  companyEmail
  email
  emergencyContact
  emergencyPhone
  employeeDepartmentId
  employeeDisplayName
  employeeGenderId
  employeeGroupId
  employeeId
  employeeOfficeId
  employeeSuffixId
  ext
  firstName
  fullName
  id
  lastName
  middleName
  nickname
  personalEmail
  phoneNumber
  relationship
  title
  userId
  managerId
}
    `;